import EventEmitter from 'eventemitter3'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

const bus = new EventEmitter()

window.addEventListener('touchstart', handleTouchStart, false)
window.addEventListener('resize', debounce(_ => bus.emit('windowResize'), 100), false)
window.addEventListener('scroll', throttle(_ => bus.emit('windowScroll'), 50), false)

function handleTouchStart(evt) {
  bus.emit('isTouch', { origEvent: evt })
  window.removeEventListener('touchstart', handleTouchStart)
}

export default bus
